// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3FrX9","title":"Info_title__dWoEv","selects":"Info_selects__risDo","requiredAsterisk":"Info_requiredAsterisk__vbiJ9"};